module.exports = __webpack_public_path__ + "img/Elektrische boilers.a2819ab6.svg";